module.exports = __webpack_public_path__ + "static/media/report_arrLeft.40fe0ffe.svg";